module.exports = __webpack_public_path__ + "img/slika49.07846309.jpg";